import { now } from "../firebase";

export default class TestCases {
  db: firebase.firestore.Firestore;
  collection: firebase.firestore.CollectionReference;

  constructor(db: firebase.firestore.Firestore, uid: string) {
    this.db = db;
    this.collection = db
      .collection("users")
      .doc(uid)
      .collection("testCases");
  }

  all(): Promise<any[]> {
    return this.collection
      .orderBy("created")
      .get()
      .then(function(querySnapshot: any) {
        let testCases: any[] = [];
        querySnapshot.forEach(function(doc: any) {
          testCases.push({
            id: doc.id,
            attrs: { testSuitId: "default", ...doc.data() }
          });
        });
        return testCases;
      });
  }

  create(attrs: any): Promise<any> {
    attrs = { ...attrs, created: now() };
    return this.collection
      .add(attrs)
      .then(doc => ({ id: doc.id, attrs: attrs }));
  }

  delete(id: any): void {
    this.collection.doc(id).delete();
  }

  update(id: any, attrs: any): Promise<any> {
    return this.collection
      .doc(id)
      .set(attrs)
      .then(() => ({ id: id, attrs: attrs }));
  }
}
